import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Col, Row } from 'react-bootstrap'
import { SectionHeading } from 'components/headings'
import { InfoButton } from 'components/buttons'
import RegistrySideNavContainer from 'registry/components/registry-sidenav'
import { SHOP_REGISTRY } from 'registry/constants'
import RegItemCardGhostList from 'registry/components/reg-item-card-ghost'
import { getEligibleForRegistryDiscount } from 'registry/reducers'
import { storePath } from 'lib/urls'
import { RegistryDiscountIcon } from 'components/icons'
import { openRedirectModal } from 'registry/modals/actions'
import { CONFIG } from 'shared/constants'
import { useShopRegistryItems } from '../api/hooks'
import StoreSection from './components/store-section'
import BenefitsCarousel from './components/benefits-carousel'
// eslint-disable-next-line import/no-unresolved
import FTCDisclosureTag from '../../components/FTCDisclosureTag'

export const NoRegItemsView = ({ registryDiscountAvailable }) => {
  let msg

  if (registryDiscountAvailable) {
    msg = (
      <span className="text-center pal">
        There's nothing to buy from your registry.{' '}
        <span className="text-bold">
          Want to shop with your single-use{' '}
          {CONFIG.store.registryDiscountPctDisplay} registry discount?
        </span>
      </span>
    )
  } else {
    msg = (
      <span className="text-bold text-center pal">
        There's nothing to buy from your registry.
      </span>
    )
  }

  return (
    <div className="flex col center paxl" style={{ minHeight: 400 }}>
      <RegistryDiscountIcon height={80} />
      {msg}
      <InfoButton href={storePath} pill>
        Shop the Babylist Shop
      </InfoButton>
    </div>
  )
}

NoRegItemsView.propTypes = {
  registryDiscountAvailable: PropTypes.bool.isRequired,
}

export const ShopRegistry = ({
  registry,
  registryDiscountAvailable,
  openRedirectModal,
}) => {
  const { id } = registry
  const { data, isLoading } = useShopRegistryItems(id)
  useEffect(() => {
    document.getElementById('header').classList.add('position-sticky')
    return () => {
      document.getElementById('header').classList.remove('position-sticky')
    }
  }, [registry])

  return (
    <>
      <div className="container mts mtl-sm pbxl">
        <Row>
          <Col sm={3} md={3} xl={2} className="hidden-xs">
            <RegistrySideNavContainer activeNav={SHOP_REGISTRY} />
          </Col>

          <Col sm={9} md={9} xl={10}>
            <SectionHeading className="mtxl-md mbxl-md">
              Shop Your Registry
            </SectionHeading>
            <BenefitsCarousel />
            <FTCDisclosureTag className="mtxl" />
            {isLoading && <RegItemCardGhostList />}
            <div className="ptl">
              {data && data.length === 0 && (
                <NoRegItemsView
                  registryDiscountAvailable={registryDiscountAvailable}
                />
              )}
              {data &&
                data.length > 0 &&
                data.map((section) => {
                  const { storeDisplayName, storeName, items } = section
                  if (!section.storeName) {
                    return false
                  }
                  return (
                    <StoreSection
                      key={storeName}
                      label={storeDisplayName}
                      items={items}
                      registryDiscountAvailable={registryDiscountAvailable}
                      storeName={storeName}
                      openRedirectModal={openRedirectModal}
                    />
                  )
                })}
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}

ShopRegistry.propTypes = {
  openRedirectModal: PropTypes.func.isRequired,
  registry: PropTypes.object.isRequired,
  registryDiscountAvailable: PropTypes.bool,
}

ShopRegistry.defaultProps = {
  registryDiscountAvailable: false,
}

const mapStateToProps = (state) => {
  return {
    registryDiscountAvailable: getEligibleForRegistryDiscount(state),
  }
}

export default connect(mapStateToProps, { openRedirectModal })(ShopRegistry)
